import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Custom hook to track page views on route changes
 */
export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        // Track page view whenever the route changes
        trackPageView(location.pathname + location.search);
    }, [location]);
};

/**
 * Get page title based on route
 */
export const getPageTitle = (pathname: string): string => {
    const titles: Record<string, string> = {
        '/': 'Home',
        '/splash': 'Welcome',
        '/auth': 'Authentication',
        '/dashboard': 'Canvas',
        '/dashboard/files': 'Knowledge Base',
        '/dashboard/workdashboard': 'Work Dashboard',
        '/integrations': 'Integrations',
        '/admin': 'Admin Dashboard',
    };

    // Find matching title or generate from path
    const exactMatch = titles[pathname];
    if (exactMatch) return exactMatch;

    // Check for partial matches (e.g., /dashboard/files/123)
    for (const [path, title] of Object.entries(titles)) {
        if (pathname.startsWith(path)) {
            return title;
        }
    }

    // Generate title from path
    const segments = pathname.split('/').filter(Boolean);
    return segments.map(s => 
        s.charAt(0).toUpperCase() + s.slice(1).replace(/-/g, ' ')
    ).join(' - ') || 'Page';
};